import { DossierId, DossierReference } from '@/dossier/models/AbstractDossier';
import { OutletId } from '@/shared/models/Outlet';
import { RegistrationNumber } from '@/vehicle/models/Vehicle';

export default class SurveyDossier {
  id!: DossierId;
  externalReference: DossierReference | null = null;
  outletId!: OutletId;
  registrationNumber: RegistrationNumber | null = null;
  modelDescription: string | null = null;
  contactNames: Array<string> = [];
}
